import { Component, OnInit, ViewChild } from '@angular/core';
import { provideEchartsCore } from 'ngx-echarts';
import { CardModule } from 'primeng/card';
import { BarChart, SunburstChart } from 'echarts/charts';
import { GridComponent, LegendComponent, TooltipComponent } from 'echarts/components';
import { CanvasRenderer } from 'echarts/renderers';
import { ChartService } from './service/chart.service';
import { ImportHistoryComponent } from '../import/catalog-import/import-history/import-history.component';
import * as echarts from 'echarts/core';
import { ButtonModule } from 'primeng/button';
import { NotificationComponent } from '../../utils/notification/notification.component';
import { UserService } from '../user/services/user.service';
import { AvatarModule } from 'primeng/avatar';
import { Router } from '@angular/router';

echarts.use([BarChart, SunburstChart, GridComponent, CanvasRenderer, TooltipComponent, LegendComponent]);

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [
    CardModule,
    ButtonModule,
    NotificationComponent,
    AvatarModule
  ],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss',
  providers: [provideEchartsCore({ echarts })],
})
export class DashboardComponent implements OnInit {
  typologyOption;
  barChartOption;
  legendData: { name: string; color: string }[] = [];
  user;

  @ViewChild(ImportHistoryComponent) importHistoryComponent: ImportHistoryComponent;

  constructor(
    private readonly chartService: ChartService,
    private readonly userService: UserService,
    private readonly router: Router,
  ) {}

  ngOnInit(): void {
    this.user = this.userService.getUser();
    this.barChartOption = this.chartService.toBarChart();
    if(this.user?.operator) {
      this.router.navigate(['operator/catalog']);
    } else {
      this.router.navigate(['seller/catalog']);
    }
  }

  fakeCall() {
    this.chartService.fake().subscribe({
      next: () => {
         console.log('success');
      },
    });
  }
}
